import {createRef, useEffect, useRef, useState} from 'react'
import {Modal} from 'react-bootstrap'
import SignaturePad from 'react-signature-pad-wrapper'
import Swal from 'sweetalert2'
import {KTSVG, toAbsoluteUrl} from '../../../../../../../../_metronic/helpers'
import {getSnackBar, getSnackBarToast} from '../../../../../../util/snackBar'
import {uploadSignatureGuestService} from '../../../../services/guest.service'

const HtmlToReact = ({htmlString}) => {
  return <div dangerouslySetInnerHTML={{__html: htmlString}} />
}

const ModalTyC = ({show, setShow, getChekings, guestInfo, tycInfo, handleCreateCheckIn}) => {
  // const {currentTabItem} = useHoteleria()
  const [isReaded, setIsReaded] = useState(false)
  // const [activeButton, isActiveButton] = useState(false)
  const [isChecked, setIsChecked] = useState(false)
  // const [, setIsSigned] = useState(false)
  const signaturePadRef = createRef()
  // const [tyCHtml, setTycHtml] = useState('')
  // const [, setImageValue] = useState('')
  const divRef = useRef()
  // var imgWidth
  // var imgHeight

  const [isAtBottomReached, setIsAtBottomReached] = useState(false)

  const handleClearSignature = async () => {
    const signaturePad = signaturePadRef.current
    signaturePad?.clear()
  }

  useEffect(() => {
    const handleScroll = () => {
      if (divRef.current) {
        const divHeight = divRef.current.clientHeight
        const scrollTop = divRef.current.scrollTop
        const scrollHeight = divRef.current.scrollHeight

        const isAtBottom = divHeight + scrollTop >= scrollHeight

        // Set isReaded to true when scrolling reaches the bottom for the first time
        if (!isAtBottomReached && isAtBottom) {
          setIsReaded(true)
          setIsAtBottomReached(true)
        }
      }
    }

    if (divRef.current) {
      divRef.current.addEventListener('scroll', handleScroll)
      const scrollHeight = divRef.current.scrollHeight
      if (scrollHeight <= 300) {
        setIsReaded(true)
      }
    }

    return () => {
      if (divRef.current) {
        divRef.current.removeEventListener('scroll', handleScroll)
      }
    }
  }, [])

  // const startSign = () => {
  //   var isInstalled = document.documentElement.getAttribute('SigPlusExtLiteExtension-installed')
  //   if (!isInstalled) {
  //     alert(
  //       'SigPlusExtLite extension is either not installed or disabled. Please install or enable extension.',
  //     )
  //     return
  //   }
  //   var canvasObj = document.getElementById('cnv')
  //   canvasObj.getContext('2d').clearRect(0, 0, canvasObj.width, canvasObj.height)
  //   setIsSigned(false)
  //   setImageValue('')
  //   imgWidth = canvasObj.width
  //   imgHeight = canvasObj.height
  //   var message = {
  //     firstName: '',
  //     lastName: '',
  //     eMail: '',
  //     location: '',
  //     imageFormat: 1,
  //     imageX: imgWidth,
  //     imageY: imgHeight,
  //     imageTransparency: false,
  //     imageScaling: false,
  //     maxUpScalePercent: 0.0,
  //     rawDataFormat: 'ENC',
  //     minSigPoints: 25,
  //   }
  //   // eslint-disable-next-line no-restricted-globals
  //   top.document.addEventListener('SignResponse', signResponse, false)
  //   var messageData = JSON.stringify(message)
  //   var element = document.createElement('MyExtensionDataElement')
  //   element.setAttribute('messageAttribute', messageData)
  //   document.documentElement.appendChild(element)
  //   var evt = document.createEvent('Events')
  //   evt.initEvent('SignStartEvent', true, false)
  //   element.dispatchEvent(evt)
  // }

  // const signResponse = (event) => {
  //   var str = event.target.getAttribute('msgAttribute')
  //   var obj = JSON.parse(str)
  //   setValues(obj, imgWidth, imgHeight)
  // }

  // const setValues = (objResponse, imageWidth, imageHeight) => {
  //   var obj = null
  //   if (typeof objResponse === 'string') {
  //     obj = JSON.parse(objResponse)
  //   } else {
  //     obj = JSON.parse(JSON.stringify(objResponse))
  //   }

  //   var ctx = document.getElementById('cnv').getContext('2d')

  //   if (obj.errorMsg != null && obj.errorMsg != '' && obj.errorMsg != 'undefined') {
  //     alert(obj.errorMsg)
  //   } else {
  //     if (obj.isSigned) {
  //       var img = new Image()
  //       img.onload = function () {
  //         ctx.drawImage(img, 0, 0, imageWidth, imageHeight)
  //       }
  //       img.src = 'data:image/png;base64,' + obj.imageData
  //       setImageValue(obj.imageData)
  //       setIsSigned(true)
  //     }
  //   }
  // }

  const handleClose = () => {
    setShow(false)
  }

  const onSubmit = async () => {
    // const binaryData = atob(imageValue)
    // const arrayBuffer = new ArrayBuffer(binaryData.length)
    // const uint8Array = new Uint8Array(arrayBuffer)

    // for (let i = 0; i < binaryData.length; i++) {
    //   uint8Array[i] = binaryData.charCodeAt(i)
    // }
    // const blob = new Blob([uint8Array])
    // const formData = new FormData()
    // formData.append('file', blob, `Firma-${guestInfo.Id}.png`)

    const signaturePad = signaturePadRef.current

    if (!signaturePad) {
      return
    }
    try {
      if (signaturePad.isEmpty()) {
        // eslint-disable-next-line no-alert
        Swal.fire('El huesped debe firmar primero.', '', 'warning')
      } else {
        let imageValue = signaturePad.toDataURL()
        const binaryData = atob(imageValue.replace('data:image/png;base64,', ''))
        const arrayBuffer = new ArrayBuffer(binaryData.length)
        const uint8Array = new Uint8Array(arrayBuffer)
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i)
        }
        //window.open(signaturePad.toDataURL());
        const blob = new Blob([uint8Array])
        const formData = new FormData()
        formData.append('file', blob, `Firma-${guestInfo.Id}.png`)

        const response = await uploadSignatureGuestService(formData, guestInfo.Id)
        if (!response.data.error) {
          getSnackBarToast('Se logró aceptar los terminos y condiciones con exito', 'success')
          handleCreateCheckIn()
          handleClose()
        } else {
          getSnackBarToast('Hubo un error', 'error')
        }
      }
    } catch (error) {
      getSnackBarToast('Hubo un error', 'error')
    }
  }

  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-lg'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>Aceptar Términos y Condiciones</h5>
          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          {!tycInfo.ModRecepcion ? (
            <>
              <div className='d-flex justify-content-center flex-column align-items-center'>
                <div>
                  <img alt='Exito' src={toAbsoluteUrl('/media/logos/close.png')} />
                </div>
                <div className='d-flex flex-column align-items-center mt-3'>
                  <div className='fs-1 fw-bolder'>
                    No se tiene habilitado los terminos y condiciones para Checkin.
                  </div>
                  {!tycInfo.ModParqueoDeBuses && (
                    <div className='fs-4 fw-bolder'>{`Utiliza la modalidad de parqueo de buses para firmar TyC`}</div>
                  )}
                  {!tycInfo.ModAutoservicioTotem && (
                    <div className='fs-4 fw-bolder'>{`Utiliza la modalidad de autoservicio totem para firmar TyC`}</div>
                  )}
                  {!tycInfo.ModCheckInAppHuesped && (
                    <div className='fs-4 fw-bolder'>{`Utiliza la modalidad de App Huesped totem para firmar TyC`}</div>
                  )}
                  <div className='fs-4 fw-bolder'>{`Si desea habilitarlo ingrese a Gestion de Reserva / Terminos y condiciones.`}</div>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className='row p-3 pb-5'>
                <div
                  ref={divRef}
                  style={{
                    maxHeight: '300px',
                    overflowY: 'auto',
                    border: '1px solid #ccc',
                    padding: '10px',
                  }}
                >
                  <HtmlToReact htmlString={tycInfo.TyC || ''} />
                </div>
                <div className='d-flex align-items-end p-0'>
                  <input
                    className='form-check-input widget-9-check mt-2'
                    type='checkbox'
                    onChange={() => setIsChecked(!isChecked)}
                    disabled={!isReaded}
                    value={isChecked}
                  />
                  <span className='mt-1 ms-2'>He leido los terminos y condiciones</span>
                </div>
                <div style={{padding: '10px 0px'}}>
                  {/*<table cellPadding='0' style={{border: '1px solid #ccc', width: '100%'}}>*/}
                  {/*  <tbody>*/}
                  {/*    <tr>*/}
                  {/*      <td height='100' width='500'>*/}
                  {/*        <canvas id='cnv' width={imgWidth} height={imgHeight}></canvas>*/}
                  {/*      </td>*/}
                  {/*    </tr>*/}
                  {/*  </tbody>*/}
                  {/*</table>*/}
                  {/* <input
                    id='SignBtn'
                    name='SignBtn'
                    type='button'
                    value='Firmar'
                    className='btn btn-primary mt-2'
                    onClick={startSign}
                  /> */}
                  <div className='border mt-2'>
                    <SignaturePad redrawOnResize ref={signaturePadRef} width={500} height={150} />
                  </div>
                  <div className={'mt-3'}>
                    {' '}
                    (
                    <button
                      onClick={handleClearSignature}
                      type={'button'}
                      className={'btn btn-link'}
                    >
                      Borrar firma
                    </button>
                    ){' '}
                  </div>
                </div>
              </div>
            </>
          )}

          <div className='d-flex justify-content-center mb-3'>
            <button type='button' className='btn btn-light-primary me-5' onClick={handleClose}>
              Cancelar
            </button>
            {tycInfo.ModRecepcion ? (
              <>
                <button
                  type='button'
                  className='btn btn-primary'
                  onClick={onSubmit}
                  disabled={!(isReaded && isChecked)}
                >
                  Guardar
                </button>
              </>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    </Modal>
  )
}

export {ModalTyC}
